import * as types from './types';

const resource = { data: null, isLoading: false, isLoaded: false };
const initialState = { psychologist: resource, nutritionist: resource };

const actionToProfile = {
  [types.FETCH_SELF_PSYCHOLOGIST]: 'psychologist',
  [types.UPDATE_SELF_PSYCHOLOGIST]: 'psychologist',
  [types.FETCH_SELF_NUTRITIONIST]: 'nutritionist',
  [types.UPDATE_SELF_NUTRITIONIST]: 'nutritionist',
};

export default function specialistProfileReducer(state = initialState, { type, payload }) {
  const base = type.replace(/_(PENDING|FULFILLED|REJECTED)$/, '');
  const name = actionToProfile[base];
  if (!name) return state;

  if (type.endsWith('_PENDING')) {
    return { ...state, [name]: { ...state[name], isLoading: true } };
  }
  if (type.endsWith('_FULFILLED')) {
    return { ...state, [name]: { data: payload, isLoading: false, isLoaded: true } };
  }
  if (type.endsWith('_REJECTED')) {
    return { ...state, [name]: { ...state[name], isLoading: false, isLoaded: true } };
  }
  return state;
}
